/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useNavigate } from 'js/lib/useRouter';

import { Card, Typography2, breakpoints } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-collections';

type PropsFromCaller = {
  programName: string;
  subTitle: string;
  description: string;
  redirectUrl: string;
};

const styles = {
  container: css`
    max-width: 50%;
    margin-bottom: var(--cds-spacing-400);
    margin-top: 0;

    ${breakpoints.down('xs')} {
      max-width: 100%;
      margin-top: var(--cds-spacing-300);
      margin-bottom: var(--cds-spacing-300);
    }
  `,

  title: css`
    margin-bottom: var(--cds-spacing-150);
  `,

  card: css`
    &:hover {
      cursor: pointer;
    }
  `,

  innerDiv: css`
    padding: var(--cds-spacing-100);
  `,
};

const MerchandisingCard = ({ programName, subTitle, description, redirectUrl }: PropsFromCaller) => {
  const navigate = useNavigate();

  const onClickCard = () => {
    navigate(redirectUrl);
  };

  return (
    <div css={styles.container}>
      <Typography2 variant="subtitleLarge" component="h3" css={styles.title}>
        {_t('Explore more in #{programName}', { programName })}
      </Typography2>
      <Card interactive css={styles.card} onClick={onClickCard} role="link">
        <div css={styles.innerDiv}>
          <Typography2 variant="subtitleMedium" component="p">
            {subTitle}
          </Typography2>
          <Typography2 variant="bodyPrimary" component="p" color="supportText">
            {description}
          </Typography2>
        </div>
      </Card>
    </div>
  );
};

export default MerchandisingCard;
